import FormItem from "@components/formItem";
import NextIcon from "@layouts/v4/authPopup/icons/Next.jsx";
import PrevIcon from "@layouts/v4/authPopup/icons/Prev.jsx";
import ArrowRightActive from "@pages/profile-v2/assets/icons/ArrowRightActive.jsx";
import FloatingLabelInput from "@pages/profile-v2/pages/deposit/FloatingLabelInput/index.js";
import { StakeFieldWrapper } from "@pages/profile-v2/pages/deposit/baseItems.js";
import { formatMoney } from "@pages/profile-v2/utils/index.js";
import { BoxWrapper } from "@pages/profile/withdraw/baseItems.js";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Translate } from "react-localize-redux";
import PaymentSelect from "../../../../../components/paymentSelect/index.jsx";
import * as logos from "../../../assets/paymentLogos/onwhite/index.js";
import {
	Box,
	BoxTitle,
	Caution,
	Content,
	ContentTitle,
	ExternalButton,
	ExternalDescription,
	ExternalWrapper,
	Feature,
	FeatureBankName,
	Logo,
	MinMaxInfo,
	Navigation,
	NavigationItem,
	Page,
	PaymentImg,
	PaymentWrapper,
	Title,
} from "../baseItems";

var cardValidator = require("card-validator");

export class Withdraw extends Component {
	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			currentStep: 1,
			selectedBonus: null,
			stake: null,
			externalUrl: null,
			showSuccessWindow: false,
			showFailWindow: false,
			claimsBonus: false,
			canForward: false,
			bonusId: "",
			cryptocurrency: "",
			selectedCurrency: "",
			account: "",
			bankName: "",
			branchCode: "",
			phoneNumber: "",
			ssn: "",
			senderSSN: "",
			idExpirationDate: "",
			fullName: "",
			iban: "",
			isWalletMaskVisible: false,
			accountValue: "",
			open: false,
			selectedItem: null,
			bankList: [],
		};
		this.registeredFields = {};
		this.walletInputRef = React.createRef();
	}

	componentDidMount() {
		const { selectedWithdraw } = this.props;
		const { selectedCurrency } = this.state;
		const currencies = selectedWithdraw?.currencies || [];
		const hasTry = currencies.some((item) => item.currency === "TRY");
		if (!selectedCurrency && hasTry) {
			this.setState({ selectedCurrency: "TRY" });
		}
	}

	onBackToWithdrawPage = () => {
		this.setState({
			currentStep: 1,
			stake: null,
			selectedBonus: null,
			externalUrl: null,
			showFailWindow: false,
			showSuccessWindow: false,
			showSmsWindow: false,
			claimsBonus: false,
			canForward: false,
			bonusId: "",
			cryptocurrency: "",
			selectedCurrency: "",
			account: "",
			bankName: "",
			phoneNumber: "",
			branchCode: "",
			ssn: "",
			senderSSN: "",
			idExpirationDate: "",
			fullName: "",
			iban: "",
		});
		this.props.onBackToWithdrawPage();
	};

	getCurrencyIcon(code) {
		if (code == "EUR") {
			return String.fromCharCode(8364);
		} else if (code == "TRY") {
			return String.fromCharCode(8378);
		} else {
			return;
		}
	}

	getFullName() {
		if (this.props.user && this.props.user.UserAttributes) {
			let values = this.props.user.UserAttributes.reduce((result, item) => {
				result[item.Name] = item.Value;
				return result;
			}, {});
			return `${values.given_name} ${values.family_name}`;
		}
		return null;
	}

	checkCreditCardNumber = (cardNumber) => {
		if (cardNumber) {
			let replacedCardNumber = cardNumber.replaceAll("/", "").replaceAll("_", ""),
				result = cardValidator.number(replacedCardNumber);
			return result.isValid;
		}
		return false;
	};

	getCardType = (cardNumber) => {
		if (cardNumber) {
			let replacedCardNumber = cardNumber.replaceAll("/", "").replaceAll("_", ""),
				result = cardValidator.number(replacedCardNumber);
			return result.card.type;
		}
		return null;
	};

	checkHolderName = (name) => {
		if (name) {
			let result = cardValidator.cardholderName(name);
			return result.isValid;
		}
		return false;
	};

	checkExpirationDate = (date) => {
		if (date) {
			let splitedDate = date.replaceAll("_", "").split("/"),
				resultMonth = cardValidator.expirationMonth(splitedDate[0]),
				resultYear = cardValidator.expirationYear(splitedDate[1]);
			return resultMonth.isValid && resultYear.isValid;
		}
		return false;
	};

	checkCvv = (cvv) => {
		if (cvv) {
			let result = cardValidator.cvv(cvv);
			return result.isValid;
		}
		return false;
	};

	checkRequiredFields = (showWarning) => {
		let flag = false;
		let missingFields = [];
		//todo: improve beause we can get regex and
		Object.keys(this.registeredFields).map((i) => {
			const val = this.state[i];
			if (val === "" || val === null || val === undefined) {
				flag = true;
				missingFields.push(i);
			}
		});
		if (flag) {
			if (showWarning) {
				this.props.showAlert({
					type: "error",
					msg: "ALL_FIELDS_WARNING",
					title: "ERROR",
				});
			}
			this.setState({ canForward: false });
			return false;
		}
		this.setState({ canForward: true });
		return true;
	};

	//override for custom check not here
	customCheck = () => {
		return true;
	};

	goForward(step) {
		const newStep = step + 1,
			{ stake, selectedCurrency, account } = this.state,
			{ selectedWithdraw } = this.props;
		const currency = selectedWithdraw.currencies.find(
			(item) => item.currency == (selectedCurrency || "TRY")
		);
		switch (newStep) {
			case 2: {
				if (
					(selectedWithdraw.method === "ATM Kartsız Çekim" ||
						selectedWithdraw.method === "ATM Cardless Withdrawal") &&
					selectedCurrency === "TRY"
				) {
					if (stake?.toString().length >= 3 && stake % 100 !== 0) {
						this.props.showAlert({
							type: "error",
							msg: "STAKE_TRY_WARNING",
							title: "ERROR",
						});
						return this.setState({ stake: "" });
					}
				}

				if (!this.checkRequiredFields(true)) {
					return;
				}
				if (!this.customCheck()) {
					return;
				}
				if (account.length > 9 && selectedWithdraw.method === "Odendibil") {
					this.props.showAlert({
						type: "error",
						msg: "ACCOUNT_WARNING",
						title: "ERROR",
					});
					return;
				}
				if (selectedWithdraw.method !== "BankTransfer") {
					if (
						currency &&
						currency.withdraw &&
						currency.withdraw.min &&
						currency.withdraw.max
					) {
						if (stake < currency.withdraw.min) {
							this.props.showAlert({
								type: "error",
								msg: "STAKE_RANGE_WARNING_MIN",
								title: "ERROR",
							});
							return;
						}
						if (stake > currency.withdraw.max) {
							this.props.showAlert({
								type: "error",
								msg: "STAKE_RANGE_WARNING_MAX",
								title: "ERROR",
							});
							return;
						}
					}
				}
				this.setState({
					currentStep: newStep,
				});
				break;
			}
			default:
				this.setState({
					currentStep: newStep,
				});
		}
	}
	goBack(step) {
		this.setState({
			currentStep: step,
		});
	}

	roundToNearestHundred(value) {
		return Math.round(value / 100) * 100;
	}

	onEnterValue(name, e) {
		const { selectedWithdraw } = this.props;
		let value = e.target.value.replace(/_/g, "").trim();
		this.setState({ [name]: value, [`${name}Value`]: value }, this.checkRequiredFields);

		if (
			(selectedWithdraw.method === "ATM Kartsız Çekim" ||
				selectedWithdraw.method === "ATM Cardless Withdrawal") &&
			this.state.selectedCurrency === "TRY" &&
			name === "stake"
		) {
			if (value?.length >= 3 && value % 100 !== 0) {
				this.props.showAlert({
					type: "error",
					msg: "STAKE_TRY_WARNING",
					title: "ERROR",
				});
				value = 0;
			}
		}
		switch (name) {
			case "stake": {
				let v = e.target.value;
				v = v ? parseInt(v) : 0;
				this.setState(
					{
						stake: v,
					},
					() => {
						this.checkRequiredFields(false);
					}
				);
				break;
			}
			default: {
				let newState = { ...this.state };
				newState[name] = e.target.value;
				this.setState(newState, () => {
					this.checkRequiredFields(false);
				});
			}
		}
	}

	getMethodLogo(method) {
		if (method.indexOf("Monetix") > -1) {
			return logos[method];
		}
		switch (method) {
			case "Centralpay":
				return logos["payfix"];
			case "Payturka":
				return logos["payfix"];
			case "Payfix":
				return logos["payfix"];
			case "MFT":
				return logos["mft"];
			case "CryptoPay":
				return logos["cryptopay"];
			case "BTC ZENGİNSİN Cryptopayment":
				return logos["cryBtc"];
			case "ETH ZENGİNSİN Cryptopayment":
				return logos["cryEth"];
			case "TRX ZENGİNSİN Cryptopayment":
				return logos["cryTron"];
			case "USDT.TRC20 ZENGİNSİN Cryptopayment":
				return logos["cryUsdt"];
			case "BTC CHOKWIN Cryptopayment":
				return logos["cryBtc"];
			case "ETH CHOKWIN Cryptopayment":
				return logos["cryEth"];
			case "TRX CHOKWIN Cryptopayment":
				return logos["cryTron"];
			case "USDT.TRC20 CHOKWIN Cryptopayment":
				return logos["cryUsdt"];
			case "PEP":
				return logos["pep"];
			case "QR":
				return logos["qr"];
			case "ATM Kartsız Çekim":
				return logos["pep"];
			case "ATM Cardless Withdrawal":
				return logos["atmkartsizEn"];
			case "Papara":
				return logos["papara"];
			case "SendToFriend":
				return logos["sendtofriendEn"];
			case "Arkadaşına Gönder":
				return logos["sendtofriendTr"];
			case "Papara Fast":
				return logos["paparafastEn"];
			case "Papara Hızlı":
				return logos["paparafastTr"];
			case "Vevopay":
				return logos["vevopay"];
			case "VevopayPopy":
				return logos["vevopayPopyPara"];
			case "TurboYatirim":
				return logos["paybol"];
			case "TurboHavale":
				return logos["turbohavale"];
			case "FxCuzdan":
				return logos["fxcuzdan"];
			case "CentralPay":
				return logos["vevopay"];
			case "Safir Papara":
				return logos["sapphirepapara"];
			case "AnindaMFT":
				return logos["anindamft"];
			default:
				if (method.indexOf("88Pay") > -1) return logos["ipay88"];
				return null;
		}
	}

	onSelectCurrency(e) {
		this.setState(
			{
				selectedCurrency: e.label,
			},
			() => {
				this.checkRequiredFields(false);
			}
		);
	}

	getActiveLanguageCode() {
		let activeLanguage = this.props.languages.filter((i) => i.active == true);
		return activeLanguage[0].code;
	}

	renderMinMax() {
		const { selectedCurrency } = this.state;
		const { selectedWithdraw } = this.props;

		const currencyToUse = selectedCurrency || selectedWithdraw?.currencies?.[0]?.currency;
		const currency = selectedWithdraw.currencies.filter(
			(item) => item.currency == currencyToUse
		);
		return (
			<Translate>
				{({ translate }) => (
					<div>
						{currency && currency[0] && currency[0].withdraw && (
							<MinMaxInfo>
								{`${translate("MIN")}${formatMoney(
									currency[0].withdraw.min,
									currencyToUse
								)} - ${translate("MAX")}${formatMoney(
									currency[0].withdraw.max,
									currencyToUse
								)}`}
							</MinMaxInfo>
						)}
					</div>
				)}
			</Translate>
		);
	}

	registerField = ({ name, regex, message = "This field is required" }) => {
		this.registeredFields[name] = {
			regex,
			message,
		};
		this.checkRequiredFields(false);
	};

	getCurrencyField = (translate) => {
		const { selectedWithdraw } = this.props;
		const { selectedCurrency } = this.state;
		if (!selectedWithdraw?.currencies?.length) return null;

		const currencies = [...selectedWithdraw.currencies];
		const tryIndex = currencies.findIndex((item) => item.currency === "TRY");
		if (tryIndex > 0) {
			const [tryCurrency] = currencies.splice(tryIndex, 1);
			currencies.unshift(tryCurrency);
		}

		const options = [{ value: 0, label: translate("PLEASE_SELECT") }];
		currencies.forEach((item, idx) => {
			options.push({ value: idx + 1, label: item.currency });
		});

		const selectedValue = selectedCurrency
			? options.find((o) => o.label === selectedCurrency)?.value
			: currencies[0]
				? 1
				: options[1]?.value;

		if (!selectedCurrency && currencies[0]) {
			this.setState({ selectedCurrency: currencies[0].currency });
		}

		return (
			<Translate>
				{({ translate }) => (
					<FormItem onRegister={() => this.registerField({ name: "selectedCurrency" })}>
						<Box>
							<BoxTitle>{translate("signin-signup.currency")}</BoxTitle>
							<PaymentSelect
								options={options}
								value={selectedValue}
								handleSelect={this.onSelectCurrency.bind(this)}
							/>
						</Box>
					</FormItem>
				)}
			</Translate>
		);
	};

	getStakeField = (label, autoFocus = true) => {
		return (
			<Translate>
				{({ translate }) => (
					<FormItem onRegister={() => this.registerField({ name: "stake" })}>
						<Box>
							<FloatingLabelInput
								onWheel={(e) => e.target.blur()}
								min={0}
								autoFocus={autoFocus}
								type="number"
								onChange={this.onEnterValue.bind(this, "stake")}
								translate={translate}
								label={translate("Enter_Amount")}
							/>
						</Box>
					</FormItem>
				)}
			</Translate>
		);
	};

	getStep1(translate) {
		const { stake, selectedCurrency } = this.state;
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<BoxWrapper>
					<div>{this.getCurrencyField(translate)}</div>
					<div>
						<StakeFieldWrapper>
							<div className="stake-field">{this.getStakeField()}</div>
							<div className="min-max-field">{this.renderMinMax()}</div>
						</StakeFieldWrapper>
					</div>
				</BoxWrapper>
			</Content>
		);
	}

	getStep2(translate) {
		const { stake, account } = this.state;
		return (
			<Content>
				<ExternalWrapper>
					<ExternalDescription>
						{translate("WITHDRAW_WARNING", { stake: stake, account: account })}
					</ExternalDescription>
					<div>
						<ExternalButton
							isConfirmButton
							target="_blank"
							onClick={this.makeExternalPayment.bind(this)}>
							{translate("CONFIRM")}
						</ExternalButton>
					</div>
					<Caution>{translate("EXTERNAL_CAUTION")}</Caution>
				</ExternalWrapper>
			</Content>
		);
	}

	renderNavigationButtons = (currentStep, canForward) => {
		const navigationBtnsContainer = document.getElementById("navigation-btns");
		if (!navigationBtnsContainer) return null;

		const navigations = (
			<Navigation>
				{currentStep !== 2 && (
					<NavigationItem
						back={true}
						onClick={this.onBackToWithdrawPage}>
						<PrevIcon />
					</NavigationItem>
				)}
				{currentStep < 2 ? (
					<NavigationItem
						filled={canForward}
						onClick={() => this.goForward(currentStep)}>
						{canForward ? <ArrowRightActive /> : <NextIcon />}
					</NavigationItem>
				) : null}
			</Navigation>
		);

		return ReactDOM.createPortal(navigations, navigationBtnsContainer);
	};

	render() {
		const { currentStep, canForward } = this.state;
		const { selectedWithdraw } = this.props;
		return (
			<Translate>
				{({ translate }) => (
					<PaymentWrapper>
						<PaymentImg />
						<Page>
							<Title>
								<Logo
									src={this.getMethodLogo(selectedWithdraw.method)}
									className={selectedWithdraw.method?.indexOf("88Pay") > -1 ? "no-filter" : ""}
								></Logo>
								<FeatureBankName>
									<Feature>{selectedWithdraw.method}</Feature>
								</FeatureBankName>
							</Title>
							{currentStep === 1 && this.getStep1(translate)}
							{currentStep === 2 && this.getStep2(translate)}
						</Page>
						{this.renderNavigationButtons(currentStep, canForward)}
					</PaymentWrapper>
				)}
			</Translate>
		);
	}
}
export default Withdraw;
